module.exports = __webpack_public_path__ + "media/Immortal Dreams (Prelude to Nurua).02d85c59.mp3";